<template>
  <generic-modal
    :title="$t('transaction list')"
    ref="generic_modal"
    :is_wide="true"
  >
    <generic-table
      ref="datatable"
      :title="$t('account transactions')"
      :columns="columns"
      :column_search="true"
      mode="table"
      resource_url="/accounting/transaction/datatables"
      :extra_data="{ uuid: account_uuid }"
    >
    </generic-table>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  generate_datatables_button,
  get_currency_settings,
  format_currency,
  format_date,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";

export default {
  name: "TransactionListModal",
  components: { GenericModal, GenericTable },
  data() {
    let v = this;
    return {
      account_uuid: "",
      columns: [
        {
          title: v.$t("name"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("credit"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.credit || "");
          },
        },
        {
          title: v.$t("debit"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.debit || "");
          },
        },
        {
          title: v.$t("policy"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${row.policy.policy_type.name}</div>
                    <div class="subtitle is-6 mb-0">${v.$t(
                      row.policy.type
                    )}</div>
                    <div class="subtitle is-6 mb-0">${format_date(
                      row.policy.date
                    )}</div>`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_date_time(row.create_date) || "";
        //   },
        // },
      ],
      error: "",
    };
  },
  computed: {},
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(account_uuid) {
      let v = this;
      v.set_initial_state();
      v.account_uuid = account_uuid;
      setTimeout(() => {
        v.refresh();
      }, 200);
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.account_uuid = "";
      v.error = "";
      v.$refs.datatable.destroy();
      // v.uuid = "";
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "V":
          return v.$t("valid");
        case "X":
          return v.$t("void");
        default:
          return status_code;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
